import { render, staticRenderFns } from "./FideicomisoHeader.vue?vue&type=template&id=3f09454f&scoped=true&"
import script from "./FideicomisoHeader.vue?vue&type=script&lang=js&"
export * from "./FideicomisoHeader.vue?vue&type=script&lang=js&"
import style0 from "./FideicomisoHeader.vue?vue&type=style&index=0&id=3f09454f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f09454f",
  null
  
)

export default component.exports